import color from "../../../../../constants/color";

const style = {
  card: {
    backgroundColor: "#fff",
    margin: 2,
    px: "20px",
    py: "20px",
    borderRadius: "20px",
    paddingBottom: "25px",
    "& .css-a5rdam-MuiGrid-root": {
      marginTop: "11px",
    },
  },
  heading: {
    fontSize: "20px",
    fontWeight: "600",
    pl: 2,
  },
  label: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
  },
  inputText: {
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
    mt: 1,
  },
  dropDownMenu: {
    fontSize: "14px",
    fontWeight: "400",
  },
  countryInput: {
    width: "100%",
    borderRadius: "8px",
    height: "2.5em",
    mt: 1,

    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
      padding: "8.5px 14px",
      borderRadius: "8px",
    },
    "& .css-156w56f-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    ".css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper": {
      maxWidth: "25%",
    },
  },

  inputSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    alignItems: "start",
    px: 2,
  },
  inputSections: {
    display: { sx: "block", md: "flex" },
    alignItems: "start",
    gap: 4.8,
    px: 2,
  },
  descriptionSection: {
    display: { sx: "block", md: "flex" },
    justifyContent: "space-between",
    px: 2
  },
  descriptionBox: {
    width: { xs: "100%", md: "100%", lg: "100%" }
  },
  inputBox: {
    width: { xs: "100%", md: "49%", lg: "31%" },
  },
  jobButtons: {
    borderRadius: 50,
    textTransform: "none",
    backgroundColor: "#28AA4A",
    fontSize: "14px",
    fontWeight: "500",
    px: 4,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator": {
      position: "unset",
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px",
      marginLeft: "-8px",
    },
  },
  mobile: {
    ".react-tel-input": {
      ".selected-flag": {
        ".flag": {
          mt: "-9px",
        },
      },
    },
  },
};
export default style;
